import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';

import { BehaviorSubject, lastValueFrom } from 'rxjs';
import { BaseService } from 'src/app/shared/services/base.service';
import { SocketService } from 'src/app/shared/services/socket.service';
import { Messages } from 'src/app/shared/sockets/enums/messages';
import { Client, formatClientRoom, RoomNames } from 'src/app/shared/sockets/enums/rooms';
import { IdentityDocumentTypeDto } from 'src/app/shared/dto/identity-document-type.dto';
import { IdentityDocumentTypesResponseDto } from 'src/app/shared/dto/pagination/identity-document-type-response.dto';

@Injectable({
    providedIn: 'root',
})
export class IdentityDocumentTypesService extends BaseService {
    private identityDocumentTypesSubject = new BehaviorSubject<IdentityDocumentTypeDto[]>([]);
    public identityDocumentTypes$ = this.identityDocumentTypesSubject.asObservable();

    private readonly socketService = inject(SocketService);
    constructor(httpClient: HttpClient) {
        super(httpClient, 'identity-document-type');
    }

    async setupWebSocket(): Promise<void> {
        try {
            this.identityDocumentTypesSubject.next((await this.findAll()).identityDocumentTypes);
            this.socketService.conectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.IDENTITY_DOCUMENT_TYPES_ROOM));
            this.socketService.getNotifications(Messages.IDENTITY_DOCUMENT_TYPES_CHANGED).subscribe(async () => {
                const response = await this.findAll();
                this.identityDocumentTypesSubject.next(response.identityDocumentTypes);
            });
        } catch (e: any) {
            throw new Error(`Error al establecer conexión con el socket de Tipos de Documentos de Identidad . Error: ${e.message}`);
        }
    }

    disconnectWebSocket(): void {
        this.socketService.disconnectSocketRoom(formatClientRoom(Client.DEFAULT_CLIENT, RoomNames.IDENTITY_DOCUMENT_TYPES_ROOM));
    }

    async findAll(): Promise<IdentityDocumentTypesResponseDto> {
        try {
            const request = this.httpClient.get<IdentityDocumentTypesResponseDto>(`${this.url}/findAll`);

            return (await lastValueFrom(request));
        } catch (e: any) {
            throw new Error(`No se ha encontrado ningún tipo de documento de identidad. Error: ${e.message}`);
        }
    }
}
